"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = exports.AbstractCallMetric = void 0;
const constants_1 = require("../../constants");
const utils_1 = require("../../utils");
const property_1 = require("../../decorators/property");
const mocks_1 = require("../../mocks");
class AbstractCallMetric {
    constructor(sessionId, event, data) {
        this.createdAt = (0, utils_1.smartDate)().toISOString();
        this.sessionId = sessionId;
        this.event = event;
        this.data = data;
    }
}
exports.AbstractCallMetric = AbstractCallMetric;
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", String)
], AbstractCallMetric.prototype, "sessionId", void 0);
__decorate([
    (0, property_1.Property)({ type: String, enum: constants_1.CallMetricsEventEnum }),
    __metadata("design:type", String)
], AbstractCallMetric.prototype, "event", void 0);
__decorate([
    (0, property_1.Property)({ allowMixed: 0 }),
    __metadata("design:type", Object)
], AbstractCallMetric.prototype, "data", void 0);
__decorate([
    (0, property_1.Property)({ type: String }),
    __metadata("design:type", Object)
], AbstractCallMetric.prototype, "createdAt", void 0);
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId }),
    __metadata("design:type", String)
], AbstractCallMetric.prototype, "userId", void 0);
class Stats extends AbstractCallMetric {
    constructor(sessionId, stats) {
        super(sessionId, constants_1.CallMetricsEventEnum.STATS, stats);
    }
}
class QualityChange extends AbstractCallMetric {
    constructor(sessionId, stats) {
        super(sessionId, constants_1.CallMetricsEventEnum.QUALITY_CHANGE, stats);
    }
}
class Error extends AbstractCallMetric {
    constructor(sessionId, info, error) {
        super(sessionId, constants_1.CallMetricsEventEnum.ERROR, { info, error });
    }
}
class AudioRouteChanged extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.AUDIO_ROUTE_CHANGED, data);
    }
}
class Ping extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.PING, data);
    }
}
class TrackStateChange extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.TRACK_STATE_CHANGED, data);
    }
}
class TrackCreated extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.TRACK_CREATED, data);
    }
}
class TrackStopped extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.TRACK_STOPPED, data);
    }
}
class CallStateChange extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.CALL_STATE_CHANGED, data);
    }
}
class RTCConnectionStateChange extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.RTC_CONNECTION_STATE_CHANGED, data);
    }
}
class RTCIceCandidate extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.RTC_ICE_CANDIDATE, data);
    }
}
class RTCIceCandidateError extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.RTC_ICE_CANDIDATE_ERROR, data);
    }
}
class RTCIceConnectionStateChange extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.RTC_ICE_CONNECTION_STATE_CHANGED, data);
    }
}
class RTCIceGatheringStateChange extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.RTC_ICE_GATHERING_STATE_CHANGED, data);
    }
}
class RTCNegotiationNeeded extends AbstractCallMetric {
    constructor(sessionId) {
        super(sessionId, constants_1.CallMetricsEventEnum.RTC_NEGOTIATION_NEEDED);
    }
}
class RTCSignalingStateChanged extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.RTC_SIGNALING_STATE_CHANGED, data);
    }
}
class SocketStateChange extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.SOCKET_STATE_CHANGED, data);
    }
}
class RingStateChange extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.RING_STATE_CHANGED, data);
    }
}
class CallClosed extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.CALL_CLOSED, data);
    }
}
class Log extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.LOG, data);
    }
}
class NetworkStateChanged extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.NETWORK_STATE_CHANGED, data);
    }
}
class BatteryState extends AbstractCallMetric {
    constructor(sessionId, data) {
        super(sessionId, constants_1.CallMetricsEventEnum.BATTERY_STATE, data);
    }
}
exports.Analytics = {
    AbstractCallMetric,
    Stats,
    Error,
    AudioRouteChanged,
    TrackStateChange,
    CallStateChange,
    RTCSignalingStateChanged,
    RTCNegotiationNeeded,
    RTCIceGatheringStateChange,
    RTCIceCandidateError,
    RTCIceCandidate,
    RTCIceConnectionStateChange,
    RTCConnectionStateChange,
    SocketStateChange,
    RingStateChange,
    CallClosed,
    Log,
    NetworkStateChanged,
    TrackStopped,
    TrackCreated,
    Ping,
    BatteryState,
    QualityChange,
};
